export default __webpack_public_path__ + "static/media/global-vni.15bc570b.png";